import { useState } from "react";
import { motion } from "framer-motion";
import Col from "react-bootstrap/Col";
import Carousel from "react-bootstrap/Carousel";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import tableNews from "../../../__params/tab-pages/home/tab-news";
import ModalPdf from "./c-modal-pdf";
import ModalVideo from "./c-modal-video";
import ModalImg from "./c-modal-img";

const News = () => {
  const [showPdf, setShowPdf] = useState(false);
  const [showImg, setShowImg] = useState(false);
  const [showMp4, setShowMp4] = useState(false);
  const [imgFileState, setImgFileState] = useState("");
  const [titleState, setTitleState] = useState("");
  const [linkState, setLinkState] = useState("");

  const imageVariants = {
    hover: {
      cursor: "pointer",
      scale: 0.95,
      transition: { duration: 0.5 },
    },
  };

  const handleModal = (file, title, link) => {
    if (file.slice(-3) === "pdf") return () => setShowPdf(true);
    if (file.slice(-3) === "mp4") return () => setShowMp4(true);

    return () => {
      setShowImg(true);
      setImgFileState(file);
      setTitleState(title);
      setLinkState(link);
    };
  };

  return (
    <>
      <Col xs={12} md={{ span: 7, offset: 0 }} lg={5} className="p-4">
        <Carousel fade className="text-light">
          {tableNews.map((news) => (
            <Carousel.Item key={news.id}>
              {news.file !== "#" ? (
                <>
                  <div onClick={handleModal(news.file, news.title, news.link)}>
                    <OverlayTrigger
                      className="bg-dark text-light"
                      placement="top"
                      overlay={
                        <Tooltip>Cliquez pour télécharger le document</Tooltip>
                      }
                    >
                      <motion.div
                        className=""
                        variants={imageVariants}
                        whileHover="hover"
                      >
                        <img
                          className="w-100 d-block border border-2 rounded-3"
                          src={news.img}
                          alt="Missing slide"
                        />
                      </motion.div>
                    </OverlayTrigger>
                  </div>
                  {news.file.slice(-3) === "pdf" ? (
                    <ModalPdf
                      showPdf={showPdf}
                      setShowPdf={setShowPdf}
                      title={titleState}
                      imgFile={imgFileState}
                    />
                  ) : news.file.slice(-3) === "mp4" ? (
                    <ModalVideo
                      showVideo={showMp4}
                      setShowVideo={setShowMp4}
                      title={titleState}
                      imgFile={imgFileState}
                    />
                  ) : (
                    <ModalImg
                      showImg={showImg}
                      setShowImg={setShowImg}
                      title={titleState}
                      imgFile={imgFileState}
                      link={linkState}
                    />
                  )}
                  <div
                    className="border p-2 border-top-0 border-2 rounded-3"
                    style={{ backgroundColor: "#595959" }}
                  >
                    <h5>{news.title}</h5>
                    <p>{news.texte} </p>
                    <p className="fw-bold mc-rfs-4">{news.texteGras}</p>
                    <br />
                  </div>
                </>
              ) : (
                <>
                  <a href={news.link}>
                    <motion.div
                      className=""
                      variants={imageVariants}
                      whileHover="hover"
                    >
                      <img
                        className="w-100 d-block border border-2 rounded-3"
                        src={news.img}
                        alt="Missing slide"
                      />
                    </motion.div>
                  </a>
                  <div
                    className="border p-2 border-top-0 border-2 rounded-3"
                    style={{ backgroundColor: "#595959" }}
                  >
                    <h5>{news.title}</h5>
                    <p>{news.texte} </p>
                    <p className="fw-bold mc-rfs-4">{news.texteGras}</p>
                    <br />
                  </div>
                </>
              )}
            </Carousel.Item>
          ))}
        </Carousel>
      </Col>
    </>
  );
};

export default News;
